import type React from 'react';

export interface NotificationBellProps {
	width?: string | number;
	height?: string | number;
	color?: string;
	'aria-label'?: string;
}

const NotificationBell: React.FC<NotificationBellProps> = ({
	width = 20,
	height = 22,
	color = 'currentColor',
	'aria-label': ariaLabel = 'Notifications Bell Icon',
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 36 30"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-label={ariaLabel}
		style={{ color }}
	>
		<rect
			opacity="0.1"
			width="35.7644"
			height="29.3071"
			rx="5"
			fill="currentColor"
		/>
		<path
			d="M17.5433 9.07087C17.9431 9.07087 18.0681 9.07087 18.3479 9.07087C18.6277 9.07087 18.7689 9.07087 19.1526 9.07087L25.1565 9.04979C25.4569 9.20377 25.7068 9.44074 25.8764 9.73256L17.8832 13.9402L9.90259 9.70621C10.0721 9.42622 10.3161 9.19893 10.6075 9.04979L17.5433 9.07087ZM9.64708 10.9023L17.606 15.1251C17.6906 15.17 17.7849 15.1935 17.8807 15.1937C17.9765 15.1939 18.0708 15.1706 18.1556 15.126L26.1164 10.9358V18.3634C26.1164 18.8314 25.9305 19.2802 25.5996 19.6112C25.2687 19.9421 24.8198 20.128 24.3518 20.128H11.4117C10.9437 20.128 10.4948 19.9421 10.1639 19.6112C9.83299 19.2802 9.64708 18.8314 9.64708 18.3634V10.9023ZM19.6885 8.02389C18.8279 8.02389 18.8141 8.02389 18.3479 8.02389C17.8817 8.02389 17.7409 8.02389 17.0073 8.02389L10.0711 8.00281C9.58922 8.24958 9.18484 8.62455 8.90247 9.08642C8.6201 9.54829 8.47069 10.0791 8.4707 10.6205V18.3634C8.4707 19.1434 8.78055 19.8915 9.33209 20.443C9.88362 20.9945 10.6317 21.3044 11.4117 21.3044H24.3518C25.1318 21.3044 25.8799 20.9945 26.4314 20.443C26.9829 19.8915 27.2928 19.1434 27.2928 18.3634V10.6205C27.2928 10.0791 27.1434 9.54829 26.861 9.08642C26.5787 8.62455 26.1743 8.24958 25.6924 8.00281L19.6885 8.02389Z"
			fill="currentColor"
		/>
	</svg>

);

export default NotificationBell;

